import { colors } from '@lamimed/pantheon';
import { Eye, FileDown } from 'lucide-react';

import { InfoBox } from 'components/InfoBox';

import * as S from './styles';

export interface FileBoxProps {
  fileUrl: string;
  thumbUrl?: string;
  fileTitle: string;
  fileExtension: string;
  handleView: (id: string) => void;
}

export const FileBoxView = ({
  fileUrl,
  thumbUrl,
  fileTitle,
  fileExtension,
  handleView,
}: FileBoxProps) => {
  const fileName = `${fileTitle}.${fileExtension}`;

  return (
    <S.Wrapper
      onClick={() => {
        handleView(fileUrl);
      }}
    >
      <InfoBox borderColor="neutral_light" marginTop="none">
        <InfoBox.ColumnRowView marginBottom="none">
          <S.FileContent>
            <S.FileIcon>
              <FileDown color={colors.dark} strokeWidth={1} />
            </S.FileIcon>

            {thumbUrl && (
              <S.ThumbWrapper>
                <S.Thumb
                  src={thumbUrl}
                  width={36}
                  height={36}
                  alt={`${fileTitle}-thumb`}
                  quality={100}
                />
              </S.ThumbWrapper>
            )}

            <S.Text>
              <S.Row>
                <S.SmallTypography
                  marginBottom="none"
                  variant="body_text_3"
                  color="text__primary"
                  isEllipsis
                >
                  {fileName}
                </S.SmallTypography>
              </S.Row>
            </S.Text>
          </S.FileContent>

          <S.FileIcon>
            <Eye color={colors.dark} size={40} strokeWidth={1} />
          </S.FileIcon>
        </InfoBox.ColumnRowView>
      </InfoBox>
    </S.Wrapper>
  );
};
